import { PENDING, OPEN, CLOSED } from "./constants";

export const getServiceRequestStatusColor = (status) => {
  if (status === PENDING) return "#5f5f5f";
  if (status === OPEN) return "#ffa500";
  if (status === CLOSED) return "#50a150";
  return "#183765";
};
